import React from "react";
import { Link, useHistory } from "react-router-dom";
import "../css/breadcrumb.css";
import { ReactComponent as LeftIcon } from "../assets/icons/left_arrow.svg";
import { ReactComponent as DotIcon } from "../assets/icons/dot.svg";
import {Button} from "../elements/Button";

const Breadcrumbs = ({
  addCls,
  items, // Array of { label, link, className }
  additionalLinks = [],
  headerActions,
  p0 = false,
  backLink: customBackLink
}) => {
  const history = useHistory();
  const lastIndex = items.length - 1;

  let resolvedBackLink = customBackLink;
  if (!resolvedBackLink && items && items.length > 0) {
    for (let i = items.length - 2; i >= 0; i--) {
      if (items[i]?.link) {
        resolvedBackLink = items[i].link;
        break;
      }
    }
    if (!resolvedBackLink) {
      resolvedBackLink = items[0]?.link || "/";
    }
  }

  const handleBackClick = (e) => {
    e.preventDefault();
    console.log("Breadcrumb back arrow clicked. Navigating to:", resolvedBackLink);
    if (resolvedBackLink) {
      history.push(resolvedBackLink);
    } else {
      history.push("/");
    }
  };

  return (
    <header className={`breadcrumb-header ${addCls ? addCls : ""} ${p0 === true ? `p0` : ``}`}>
      <span className="breadcrumb-title">
        <Link 
          to={resolvedBackLink || "/"} 
          onClick={handleBackClick}
          style={{ 
            color: "inherit", 
            textDecoration: "none", 
            cursor: "pointer",
            display: "inline-flex",
            alignItems: "center",
            padding: "5px 4px 5px 0px",
            marginLeft: "0px"
          }}
        >
          <LeftIcon className="clickableMiddle" style={{ marginLeft: "0px", marginRight: "10px", cursor: "pointer", transform: "translateY(2px)" }} />
        </Link>
        {items.map((item, index) => (
          <React.Fragment key={index}>
          {index !== 0 && (addCls === "bgClr1" || items.length >= 2) && (
            <DotIcon className="vaMiddle" />
          )}
            {index !== 0 && (addCls === "bgClr1" || items.length >= 2) && "\u2002\u00A0"}
            {item.link ? (
              <Link to={item.link} style={{ color: "inherit", textDecoration: "none" }}>
                {/* <label className={item.className}>{item.label}</label> */}
                  <label
                  className={`${item.className} ${
                    index === lastIndex ? "semibold-label" : ""
                  }`}
                >
                  {item.label}
                </label>

              </Link>
            ) : (
              // <label className={item.className}>{item.label}</label>
              <label
                className={`${item.className} ${
                  index === lastIndex ? "semibold-label" : ""
                }`}
              >
                {item.label}
              </label>
            )}
            &ensp;&nbsp;
          </React.Fragment>
        ))}
        {additionalLinks.map((item, index) => (
          <React.Fragment key={index}>
            {index !== 0  && <DotIcon className="vaMiddle" />}
            &ensp;&nbsp;
            {item.link ? (
              <Link to={item.link}>
                <label className={item.className}>{item.label}</label>
              </Link>
            ) : (
              <label className={item.className}>{item.label}</label>
            )}
            &ensp;&nbsp;
          </React.Fragment>
        ))}
      </span>

      <div className="breadcrumbs-actions">{headerActions}</div>
    </header>
  );
};

export default Breadcrumbs;
